import { mapActions, mapGetters } from "vuex";

export const tvaMixin = {
  computed: {
    ...mapGetters({
      tvas: "tva/list/items",
      tvasIsLoading: "tva/list/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      getTvas: "tva/list/getItems",
    }),
  },
};
